import { render, staticRenderFns } from "./dossier.vue?vue&type=template&id=5d8b68ce&scoped=true&"
import script from "./dossier.vue?vue&type=script&lang=js&"
export * from "./dossier.vue?vue&type=script&lang=js&"
import style0 from "./dossier.vue?vue&type=style&index=0&id=5d8b68ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8b68ce",
  null
  
)

export default component.exports